/**
 * Create by jiangjijing on 2020/6/24
 */
import Vue from 'vue'
import Vuex from 'vuex'
import baseState from './modules/baseState'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
  },
  modules: {
    baseState
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js